import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";
export const MuiOptionMenuWrapper = styled.div`
  .option-menu-icon {
    cursor: pointer;
    color: ${COLORS.primary_light_blue};
  }

  .visible {
    visibility: visible;
  }

  .hidden {
    visibility: hidden;
  }
`;
